<ds-modal [modal]="modal" [title]="'label_workspace_details' | translate" [maxWidthPercentage]="80">
  <app-edit-workspace
    [workspaceId]="workspaceId"
    [workspaceName]="workspaceName"
    [workspaceDescription]="workspaceDescription"
    [isModalMode]="true"
    (workspaceSaved)="onWorkspaceEdited($event)"
    (cancelled)="onCancel()"
  ></app-edit-workspace>
</ds-modal>
